import * as React from 'react';
import { Dispatch, useReducer } from 'react';

import { SmallDialog } from '../smallDialog/smallDialog.component';

import { Toasts } from './components/toasts/toasts.component';
import { smallDialogSettingsInitial } from './constants';
import { NotificationsDispatchContext, NotificationsStateContext } from './contexts/notifications.context';
import { NotificationsActions, NotificationsProviderProps, NotificationsState } from './notificationsProvider.types';
import { notificationsReducer } from './reducers/notifications.reducer';

export const NotificationsProvider: React.FC<NotificationsProviderProps> = (props: NotificationsProviderProps) => {
  const { children }: NotificationsProviderProps = props;
  const [state, dispatch]: [NotificationsState, Dispatch<NotificationsActions>] = useReducer(
    notificationsReducer,
    {
      toasts: [],
      smallDialogSettings: smallDialogSettingsInitial
    }
  );

  return (
    <NotificationsDispatchContext.Provider value={dispatch}>
      <NotificationsStateContext.Provider value={state}>
        {children}
        <Toasts />
        <SmallDialog
          settings={state.smallDialogSettings}
        />
      </NotificationsStateContext.Provider>
    </NotificationsDispatchContext.Provider>
  );
};
